/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface StatutApprenantSearch
 */
export interface StatutApprenantSearch {
    /**
     * 
     * @type {number}
     * @memberof StatutApprenantSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatutApprenantSearch
     */
    fromCrea?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatutApprenantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof StatutApprenantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof StatutApprenantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StatutApprenantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof StatutApprenantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof StatutApprenantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the StatutApprenantSearch interface.
 */
export function instanceOfStatutApprenantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatutApprenantSearchFromJSON(json: any): StatutApprenantSearch {
    return StatutApprenantSearchFromJSONTyped(json, false);
}

export function StatutApprenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatutApprenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'fromCrea': !exists(json, 'fromCrea') ? undefined : json['fromCrea'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function StatutApprenantSearchToJSON(value?: StatutApprenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'fromCrea': value.fromCrea,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

